import { render } from "./LeaderboardOverlay.vue?vue&type=template&id=507a2236&scoped=true"
import script from "./LeaderboardOverlay.vue?vue&type=script&lang=js"
export * from "./LeaderboardOverlay.vue?vue&type=script&lang=js"

import "./LeaderboardOverlay.vue?vue&type=style&index=0&id=507a2236&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507a2236"]])

export default __exports__